import clsx, { type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

const twMergeClsx = (...className: ClassValue[]) => twMerge(clsx(className));

export { twMergeClsx };
